module.exports = __webpack_public_path__ + "img/OCD_Logo_Stacked_RGB_Black.407cc267.png";